import Rest from './base/Rest';

export default class FilterParameterService extends Rest {
	static resource = 'fieldparameter';
}
